import React from 'react';

const CustomTextInput = ({ label, value, onChange, placeholder = '', disabled = false, type = 'text', style = {}, width = '100%', height = 'auto', id, required = false, error = false, helperText = '', onBlur, autoFocus = false, labelStyle = {}, htmlRequired, autoComplete, inputMode, step, min, max }) => {
  const inputHeight = height !== 'auto' ? height : '40px';
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
  const borderColor = error ? 'var(--color-error, #d32f2f)' : 'var(--color-border-input)';
  const effectiveRequired = htmlRequired === false
    ? false
    : Boolean(required || (typeof label === 'string' && label.includes('*')));
  return (
    <div style={{ width, ...style }}>
      {label && <label htmlFor={inputId} style={{ display: 'block', marginBottom: 4, color: 'var(--color-text)', fontWeight: 400, fontSize: '15px', textAlign: 'left', fontFamily: 'inherit', ...labelStyle }}>{label}</label>}
      <input
        id={inputId}
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        inputMode={inputMode}
        step={step}
        min={min}
        max={max}
        required={effectiveRequired}
        aria-label={label || placeholder}
        aria-required={effectiveRequired}
        aria-invalid={error}
        style={{
          width: '100%',
          height: inputHeight,
          padding: '8px 16px',
          borderRadius: '8px',
          border: `1px solid ${borderColor}`,
          background: 'var(--color-bg-input)',
          color: 'var(--color-text)',
          fontSize: '15px',
          fontFamily: 'inherit',
          fontWeight: 400,
          outline: 'none',
          opacity: disabled ? 0.6 : 1,
          transition: 'border 0.2s',
          boxSizing: 'border-box',
        }}
        autoFocus={autoFocus}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            e.target.blur();
          }
        }}
        onFocus={e => (e.target.style.border = error ? `1.5px solid var(--color-error, #d32f2f)` : '1.5px solid var(--color-accent)')}
        onBlur={e => {
          e.target.style.border = `1px solid ${borderColor}`;
          onBlur?.(e);
        }}
      />
      {helperText && <div style={{ marginTop: 4, fontSize: '12px', color: 'var(--color-error, #d32f2f)' }}>{helperText}</div>}
    </div>
  );
};

export default CustomTextInput; 




